<template>
  <el-dialog title="地理位置" :visible.sync="dialogTableVisible" :close-on-click-modal="false" @close="onClose" width="1200px" top="10vh">
    <div class="map-win">
      <el-amap-search-box
        class="search-box"
        :search-option="searchOption"
        :on-search-result ="onSearchResult"
      ></el-amap-search-box>
      <el-amap
        :AmapManager="AmapManager"
        v-if="dialogTableVisible"
        :center="center"
        class="amap-box"
        :vid="'amap-vue'"
        :zoom="17"
        :zooms="[4,22]"
        :clickable="true"
        @click="clickAmap"
        :plugin="plugin"
        :events="events"
        ref="amapManager"
        width="500px"
      >
        <el-amap-marker
          v-for="(marker,index) in markers"
          :key ="'marker'+index"
          :position ="marker"
        ></el-amap-marker>
      </el-amap>
    </div>
    <template slot="footer">
      <div>
        <el-button icon="el-icon-close" type="warning" @click="onClose">关 闭</el-button>
        <el-button icon="el-icon-position" type="primary" @click="onSubmit">确 定</el-button>
      </div>
    </template>
  </el-dialog>
</template>

<script>
export default {
  name: "SelectMap",
  data(){
    const self = this;
    return{
      center:[0,0],
      AmapManager:{},
      Geocoder:{},
      searchOption: {
        city: "全国",
        citylimit: false,
      },
      markers:[],
      events:{
        init:(o)=>{
          o.getCity((result)=>{
            console.log(result)
          })
        },
        click:(e)=>{
          self.center = [e.lnglat.lng, e.lnglat.lat];
          console.log(self.center)
          self.markers=[];
          self.markers.push(self.center)
          self.Geocoder.getAddress(self.center, function (status, result) { //根据坐标获取位置
            if (status === "complete" && result.info === "OK") {
              self.location_obj={
                ...result.regeocode,
                lng:e.lnglat.lng,
                lat:e.lnglat.lat,
              };
              self.input = result.regeocode.formattedAddress;
              document.querySelector(".search-box-wrapper input").value = self.input;
            }
          })
        }
      },
      plugin:[
        {
          enableHighAccuracy:true,   //是否使用高精度定位，默认true
          timeout:100,               //超过10秒后停止定位，默认：无穷大
          convert:true,          //自动偏移后的坐标为高德坐标，默认：true
          showButton:true,       //显示定位按钮，默认：true
          buttonPosition:'RB',  //定位按钮停靠位置，默认'LB'，左下角
          showMarker:true,      //定位成功后在定位到的位置显示标记，默认：true
          showCircle:true,      //定位成功后用圆圈表示定位精度范围，默认：true
          panToLocation:true,   //定位成功后将定位到的位置作为地图中心点，默认true
          zoomToAccuracy:true,   //定位成功后调整地图视野范围使定位位置及精度范围视野内可见，默认：false
          extensions:"all",
          pName:"Geolocation",     //AMap-Geolocation 定位插件
          events: {
            init(o) {
              // o 是高德地图定位插件实例
              o.getCurrentPosition((status, result) => {
                console.log(result.position)
                if (result && result.position) {
                  self.lng = result.position.lng;              //设置经度
                  self.lat = result.position.lat;              //设置纬度
                  self.center = [self.lng,self.lat];          //设置坐标
                  self.markers.push(self.center)              //获取当前定位并存入标记中显示标记点
                  self.loaded = true;                          //load
                  self.zoom = 14;
                  self.$nextTick();                            //页面渲染好后
                }
              })
            }
          }
        },
        //Geocoder编码：根据地理名称来获得地点的经纬度
        {
          pName:"Geocoder",
          events:{
            init:(o)=>{
              self.Geocoder = o; // o 则是AMap.Geocoder的实例 对外部的Geocoder变量进行赋值，在任何地方就都可以使用
              //data里的events中使用了Geocoder
              o.getAddress(self.center, function (status, result) { //根据坐标获取位置
                if (status === "complete" && result.info === "OK") {
                  self.input = result.regeocode.formattedAddress;
                  document.querySelector(".search-box-wrapper input").value = self.input;
                }
              })
            }
          }
        }],
      dialogTableVisible:false,
      location_obj:null,
      callback:null,
    }
  },
  methods:{
    show({longitude=0,latitude=0,callback}){
      const that = this;
      that.dialogTableVisible=true;
      that.markers=[];
      that.center=[longitude||113.238251,latitude||22.96694];
      (longitude&&latitude)&&that.markers.push(that.center)
      that.callback=callback;
      // that.$nextTick(function (){
      //   console.log(that.$refs.amapManager.$$getInstance())
      // })
    },
    clickAmap(e){
      console.log(e)
    },
    download(url = '', fileName = '') {
      const a = document.createElement('a');
      a.style.display = 'none';
      a.setAttribute('target', '_blank');
      /*
       * download的属性是HTML5新增的属性
       * href属性的地址必须是非跨域的地址，如果引用的是第三方的网站或者说是前后端分离的项目(调用后台的接口)，这时download就会不起作用。
       * 此时，如果是下载浏览器无法解析的文件，例如.exe,.xlsx..那么浏览器会自动下载，但是如果使用浏览器可以解析的文件，比如.txt,.png,.pdf....浏览器就会采取预览模式
       * 所以，对于.txt,.png,.pdf等的预览功能我们就可以直接不设置download属性(前提是后端响应头的Content-Type: application/octet-stream，如果为application/pdf浏览器则会判断文件为 pdf ，自动执行预览的策略)
       */
      fileName && a.setAttribute('download', fileName);
      a.href = url;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    },
    onSearchResult(pois){
      console.log(pois)
      this.input = document.querySelector('.search-box-wrapper input').value
      this.center = [pois[0].lng,pois[0].lat]        //选择了第一个值
      this.markers = [];    //标记点先清空
      this.markers.push([pois[0].lng,pois[0].lat])   //把搜索的位置的第一个值存入标记中并显示标记点
      console.log(this.markers);
    },
    onClose(){
      const that = this;
      that.dialogTableVisible=false;
      that.center=[]
      that.callback=null;
    },
    onSubmit(){
      const that = this;
      that.dialogTableVisible=false;
      that.callback(that.location_obj);
      that.center=[]
      that.callback=null;
    }
  }
}
</script>

<style lang="scss" scoped>
.el-button--primary, .el-button--danger {
  color: #fff;
}
.map-win{
  position: relative;
  .amap-box{
    width: 1180px;
    height: 600px;
  }
  .search-box{
    border: solid 1px #e8e8e8;
    position: absolute;
    top: 10px;
    left: 10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/Common/SelectMap.vue